var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { weiXinInit as weiXinInitBase, wx, proxyWx } from '@tencent/vb-web-base-core';
import { warn } from '../tools/console';
import { DefaultApiList } from './config';
import { getAppId, getJsTicket, conformProtocolWithLocation } from './helper';
/**
 * 初始化sdk的promise
 * 避免重复初始化
 */
var initPromise = null;
/**
 * 微信插件
 */
var plugin = {
    install: function (app, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            warn('wxBridge.plugin即将废弃，请使用weiXinInit方法');
            weiXinInit(options);
            return [2 /*return*/];
        });
    }); },
};
/**
 * 微信sdk初始化（权限校验）
 * 内部没有处理异常，外部可按需处理异常（无特殊需求，可不处理，因为设置分享文案是旁路功能，不应该影响主流程）
 * @param params
 * @returns
 */
var weiXinInit = function (params, jsTicket) {
    if (params === void 0) { params = {
        apiList: DefaultApiList,
    }; }
    if (jsTicket === void 0) { jsTicket = getJsTicket; }
    if (!initPromise) {
        initPromise = weiXinInitBase({
            apiList: params.apiList,
            openTagList: params.openTagList,
            getTicket: jsTicket,
        });
    }
    return initPromise;
};
/**
 * @param params 设置分享信息（包括：朋友、QQ、朋友圈、QQ空间）
 */
var setShareInfo = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var title, desc, link, imgUrl, imgUrlFormat, p1, p2;
    return __generator(this, function (_a) {
        title = params.title, desc = params.desc, link = params.link, imgUrl = params.imgUrl;
        // 未统一在入口处初始化，则在这里做按需（只包括分享api）初始化
        // 已经初始化则继续用（可是未必包含了分享api的权限声明 -- 开发和测试阶段能发现）
        // 大部分需求只用到weixin sdk中的分享内容设置，所以将其调用最简化
        if (!initPromise) {
            initPromise = weiXinInit({
                apiList: ['updateTimelineShareData', 'updateAppMessageShareData'],
            });
        }
        imgUrlFormat = conformProtocolWithLocation(imgUrl);
        p1 = proxyWx.updateAppMessageShareData({
            title: title,
            desc: desc,
            link: link,
            imgUrl: imgUrlFormat, // 分享图标
        });
        p2 = proxyWx.updateTimelineShareData({
            title: title,
            link: link,
            imgUrl: imgUrlFormat, // 分享图标
        });
        return [2 /*return*/, Promise.all([p1, p2])];
    });
}); };
var wxBridge = {
    /**
     * vue 插件
     * 待删除，没有必要做成插件形式，推荐使用weiXinInit（调用时加上warn）
     */
    plugin: plugin,
    /**
     * 带类型声明的微信对象
     */
    wx: wx,
    /**
     * 设置分享文案
     */
    setShareInfo: setShareInfo,
    /**
     * 获取当前wx appId
     */
    getAppId: getAppId,
    /**
     * 微信sdk初始化
     */
    weiXinInit: weiXinInit,
    /**
     * 加了代理后的微信对象（不用ready、且所有api均返回promise）
     */
    proxyWx: proxyWx,
};
export { wxBridge, DefaultApiList };
